import React from "react";

const About = () => {
  return (
    <div className='mb-20'>
      <h1 className='sm:text-4xl text-2xl font-bold my-6 text-gray-900'>
        About
      </h1>
      <p className='mx-auto leading-relaxed text-base mb-4'>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem esse, iste
        consectetur totam sit et neque eos eius corrupti. Accusantium quas ea id
        assumenda illo repellendus quasi unde nam consectetur excepturi dolorem
        eius repudiandae voluptates molestiae asperiores maxime ad maiores modi
        commodi velit nostrum cum, harum culpa aliquid? Quis, deserunt!
      </p>
      <p className='mx-auto leading-relaxed text-base mb-4'>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rem esse, iste
        consectetur totam sit et neque eos eius corrupti. Accusantium quas ea id
        assumenda illo repellendus quasi unde nam consectetur excepturi dolorem
        eius repudiandae voluptates molestiae asperiores maxime ad maiores modi
        commodi velit nostrum cum, harum culpa aliquid? Quis, deserunt!
      </p>
      <p className='mx-auto leading-relaxed text-base mb-4'>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Earum amet
        quibusdam, autem voluptatum odit porro reiciendis ipsam aperiam sint ut
        distinctio nobis est recusandae quasi quos modi soluta illum inventore,
        dolore sed accusantium quia voluptate. Ducimus, provident veniam. Fugit,
        reiciendis aperiam veritatis nostrum, quisquam est molestias animi
        suscipit pariatur assumenda corrupti perferendis, molestiae magnam
        nesciunt perspiciatis commodi vero quibusdam id! Expedita, incidunt.
        Culpa illo enim voluptates maxime voluptate, vel nesciunt natus
        recusandae totam dolorem saepe rerum tempora asperiores eum neque? Enim,
        voluptatum! Quo voluptatum necessitatibus labore esse nobis ratione cum
        aperiam officia rem expedita voluptate animi, rerum aspernatur quidem
        ea.
      </p>
    </div>
  );
};

export default About;